module.exports = __webpack_public_path__ + "img/img1.f891be70.jpg";